import React from 'react'

const PrimaryHeading = (props) => {
  return (
    <h2
      className={`text-center text-[clamp(38px,9.6888vw,54px)] font-semibold tracking-[-1px] text-night-black sm:tracking-5xl  ${props.class}`}
    >
      {props.children}
    </h2>
  )
}
export default PrimaryHeading
